const rand = (a, b) => Math.random() * (b - a) + a;

// ── Confetti ──────────────────────────────────────────────────────────────────
const CONFETTI_COLORS = [
  { front: "#1428A0", back: "#001080" },
  { front: "#FFD700", back: "#CCA800" },
  { front: "#22c55e", back: "#15803d" },
  { front: "#ffffff", back: "#d4d4d4" },
  { front: "#f97316", back: "#c2410c" },
  { front: "#e879f9", back: "#a21caf" },
];

export default class Confetto {
  constructor(cx, cy) {
    this.color = CONFETTI_COLORS[Math.floor(rand(0, CONFETTI_COLORS.length))];
    this.w = rand(6, 11);
    this.h = rand(10, 18);
    this.x = cx + rand(-40, 40);
    this.y = cy + rand(-20, 10);
    this.rot = rand(0, Math.PI * 2);
    this.scaleY = 1;
    this.mod = rand(0, 99);
    this.vx = rand(-10, 10);
    this.vy = rand(-20, -8);
    this.gravity = 0.38;
    this.drag = 0.065;
    this.termVel = 6;
  }
  update() {
    this.vx -= this.vx * this.drag;
    this.vy = Math.min(this.vy + this.gravity, this.termVel);
    this.vx += Math.random() > 0.5 ? rand(0, 0.5) : -rand(0, 0.5);
    this.x += this.vx;
    this.y += this.vy;
    this.scaleY = Math.cos((this.y + this.mod) * 0.09);
  }
  draw(ctx) {
    const w = this.w,
      h = this.h * this.scaleY;
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rot);
    ctx.fillStyle = this.scaleY > 0 ? this.color.front : this.color.back;
    ctx.fillRect(-w / 2, -h / 2, w, h);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }
}
